import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import PlanBuilderContent from './PlanBuilderContent';
import { jsx as _jsx } from "react/jsx-runtime";
const PlanBuilderContainer = props => {
  const isAppReady = useGlobalLoading();
  if (isAppReady) {
    return /*#__PURE__*/_jsx(PlanBuilderContent, Object.assign({}, props));
  } else {
    return /*#__PURE__*/_jsx("div", {
      style: {
        minHeight: 600,
        width: '100%'
      },
      className: "flex-column justify-center align-center",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        "data-selenium-id": "plan-builder-loading-spinner",
        size: "medium"
      })
    });
  }
};
export default PlanBuilderContainer;